import axios from 'axios';
import { Logger } from 'ia-react-core';
import LanguageServices from '../../services/LanguageServices';
import { getOnpremHostname } from '../../utils/getOnpremHostname';
import { getCloudHostname } from '../../utils/getCloudHostname';

export async function setCookies(logger: Logger) {
  const onPremHostName = getOnpremHostname();
  const cloudHostName = getCloudHostname();
  const lang = LanguageServices.getLanguageFromi18Next();
  try {
    await Promise.all([
      axios.put(`${cloudHostName}/core/ee/integration/api/v1/language`, { value: lang }, { withCredentials: true }),
      axios.put(`${onPremHostName}/eemwpna1/api/public/language`, { value: lang }, { withCredentials: true }),
    ]);
  } catch (error) {
    logger?.error(error);
  }
}
